import { produce } from 'immer';

import {
  CONTRACT_SETUP__DOCUMENT_FIELDS_FETCH_REQUEST,
  CONTRACT_SETUP__DOCUMENT_FIELDS_FETCH_SUCCESS,
  DOCUMENT_SETUP__REQUESTER_FIELDS_PAGE_OVER_DELETE,
  DOCUMENT_SETUP_CLEAR_ALL_STATE,
  DOCUMENT_SETUP_REQUESTER_CHECK_FIELD_CHANGE,
  DOCUMENT_SETUP_REQUESTER_CHECK_FIELD_INSERTED,
} from '@app/store/actionTypes';
import { ContractSetupAction } from '@app/store/contract-setup/actions';
import { RequesterCheckboxField as ContractSetupRequesterCheckboxField } from '@app/store/contract-setup/RequesterField';
import RequesterFieldType from '@app/store/contract-setup/RequesterFieldType';
import { DocumentSetupAction } from '@app/store/documentSetup/actions';
import RequesterCheckboxField from '@app/store/documentSetup/RequesterCheckboxField';

export type DocumentSetupLastRequesterCheckFieldState = RequesterCheckboxField | null;

const initialState: DocumentSetupLastRequesterCheckFieldState = null;

export default function reducer(
  state: DocumentSetupLastRequesterCheckFieldState = initialState,
  action: DocumentSetupAction | ContractSetupAction
): DocumentSetupLastRequesterCheckFieldState {
  switch (action.type) {
    case CONTRACT_SETUP__DOCUMENT_FIELDS_FETCH_REQUEST:
    case DOCUMENT_SETUP__REQUESTER_FIELDS_PAGE_OVER_DELETE:
    case DOCUMENT_SETUP_CLEAR_ALL_STATE:
      return initialState;
    case CONTRACT_SETUP__DOCUMENT_FIELDS_FETCH_SUCCESS: {
      const { requesterFields } = action.payload;
      const requesterCheckboxField = requesterFields.find(
        (requesterField): requesterField is ContractSetupRequesterCheckboxField =>
          requesterField.inputType === RequesterFieldType.CHECKBOX_FIELD
      );

      if (requesterCheckboxField) {
        const {
          checkboxInputChecked,
          dataLabel,
          id,
          positionX,
          positionY,
          positionZ,
          positionPage,
          sizeHeight,
        } = requesterCheckboxField;
        return {
          id,
          pageNumber: positionPage,
          type: 'checkbox',
          values: {
            check: checkboxInputChecked,
            dataLabel,
            size: sizeHeight,
            x: positionX,
            y: positionY,
            z: positionZ,
          },
        };
      }
      return null;
    }
    case DOCUMENT_SETUP_REQUESTER_CHECK_FIELD_CHANGE: {
      return produce(state, (draft) => {
        const { id, values } = action.payload;
        if (draft?.id === id) {
          draft.values = values;
        }
      });
    }
    case DOCUMENT_SETUP_REQUESTER_CHECK_FIELD_INSERTED: {
      return action.payload;
    }
    default:
      return state;
  }
}
